export default "__VITE_ASSET__Bn50IY7P__"